import * as React from "react";
const SvgProgressSavedIcon = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "32px", height: "32px", className: "icon save-success svg", viewBox: "0 0 32 32", ...props }, /* @__PURE__ */ React.createElement("g", { fill: "none", stroke: "#1ED061" }, /* @__PURE__ */ React.createElement("circle", { className: "circle", cx: 16, cy: 16, r: 15, style: {
  strokeWidth: 2
} }), /* @__PURE__ */ React.createElement("polyline", { className: "checkmark", points: "8,17 14,23 25,12", style: {
  strokeWidth: 2
} })));
export default SvgProgressSavedIcon;
